import { mediaimg1, mediaimg2, mediaimg3, mediaimg4 } from "assets";

export const marqueeData = [
  {
    id: 1,

    hoverImage: mediaimg1,
  },
  {
    id: 2,

    hoverImage: mediaimg2,
  },
  {
    id: 3,

    hoverImage: mediaimg3,
  },
  {
    id: 4,

    hoverImage: mediaimg4,
  },
];
